import { useFormaliteService } from '@europrocurement/l2d-domain';
import {
    FormaliteArticleOpenSearchApiApiOpensearchFormalitesGetCollectionRequest,
    FormaliteArticleOpenSearchJsonldOpensearchFormaliteArticleRead,
} from '@europrocurement/l2d-domain/openApi/ApiFormalite';

export type OffreFormalite = FormaliteArticleOpenSearchJsonldOpensearchFormaliteArticleRead &
    Record<string, unknown>;

const useOffreFormalite = () => {
    const { formaliteOpenSearchApi } = useFormaliteService();
    let searchFormaliteTimeout: number | undefined;

    const searchOfferFormalite = (search: string): Promise<Array<OffreFormalite>> =>
        new Promise((resolve, reject) => {
            clearTimeout(searchFormaliteTimeout);
            let requestParameters: FormaliteArticleOpenSearchApiApiOpensearchFormalitesGetCollectionRequest =
                {};
            if (search && search !== null) {
                requestParameters = {
                    libelle: search,
                };
            }

            searchFormaliteTimeout = setTimeout(() => {
                formaliteOpenSearchApi
                    .apiOpensearchFormalitesGetCollection(requestParameters)
                    .then((res) => resolve(res.data['hydra:member'] as Array<OffreFormalite>))
                    .catch((err) => {
                        reject(err);
                    });
            }, 600);
        });

    return { searchOfferFormalite };
};

export { useOffreFormalite };
